import type { Geometry } from './Slider';

type Props = {
  /** Status copy, e.g. "Sold out". */
  label: string;
  /** The pack's box in the slot — the badge shares it with the art. */
  pack: Geometry['pack'];
  /** Where the contained art starts inside `pack` (see `artInset`). */
  inset: { x: number; y: number };
  /** The art layer's transform and opacity, so the badge rides with the pack. */
  transform: string;
  opacity: number;
};

/**
 * Status pill over the pack art's top-left corner, half off the art — the
 * partner's sold-out mockup (Betr, 2026-10-28). A layer of its own next to
 * the art rather than inside it: the art's drop-shadow filter would shade the
 * pill too.
 */
export function SoldOutBadge({ label, pack, inset, transform, opacity }: Props) {
  return (
    <div
      className="absolute"
      style={{
        top: pack.top,
        left: `calc(50% - ${pack.w / 2}px)`,
        width: pack.w,
        height: pack.h,
        transform,
        transformOrigin: 'center center',
        opacity,
        pointerEvents: 'none',
      }}
    >
      <span
        data-co-component="SoldOutBadge"
        className="
          absolute -translate-x-[40%] -translate-y-1/2
          px-3.5 py-2
          whitespace-nowrap text-[16px] leading-[22px] font-medium tracking-[-0.31px]
          [border-radius:var(--co-SoldOutBadge-borderRadius,8px)]
          bg-[var(--co-SoldOutBadge-fill,#FFFFFF)] text-[var(--co-SoldOutBadge-text,#0E0F11)]
        "
        style={{ top: inset.y, left: inset.x }}
      >
        {label}
      </span>
    </div>
  );
}
